module.exports = __webpack_public_path__ + "img/products-services.02706326.png";